
import { useEffect, useState } from 'react';

interface ResultCardProps {
  icon: string;
  label: string;
  value: number;
  prefix?: string;
  suffix?: string;
  sublabel?: string;
  iconBg: string;
  iconColor: string;
  animate?: boolean;
}

export default function ResultCard({
  icon,
  label,
  value,
  prefix = '',
  suffix = '',
  sublabel,
  iconBg,
  iconColor,
  animate = true,
}: ResultCardProps) {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    if (!animate) {
      setDisplayValue(value);
      return;
    }

    const duration = 600;
    const steps = 30;
    const interval = duration / steps;
    let step = 0;
    const startValue = displayValue;
    const diff = value - startValue;

    const timer = setInterval(() => {
      step++;
      const progress = step / steps;
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplayValue(Math.round(startValue + diff * eased));
      if (step >= steps) clearInterval(timer);
    }, interval);

    return () => clearInterval(timer);
  }, [value]);

  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 hover:bg-white/15 transition-all duration-300 group">
      <div className="flex items-center gap-4">
        <div className={`w-12 h-12 ${iconBg} rounded-xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform`}>
          <i className={`${icon} ${iconColor} text-xl`}></i>
        </div>
        <div className="min-w-0">
          <p className="text-slate-400 text-xs font-medium mb-0.5">{label}</p>
          <p className="text-2xl font-bold text-white tabular-nums">
            {prefix}{displayValue.toLocaleString()}{suffix}
          </p>
          {sublabel && <p className="text-slate-500 text-[11px] mt-0.5">{sublabel}</p>}
        </div>
      </div>
    </div>
  );
}
